// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"581":"179dad63","878":"a4202641","913":"3022da92","972":"d2655f3a"}[chunkId] + ".chunk.js";
};